import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import routes from '../utils/routes';
import strings from '../utils/strings';
import { CText } from '../components/common';

const Splash: React.FC = () => {
  const navigate = useNavigate();
  const colors = useAppSelector((state) => state.theme.theme);
  const user = useAppSelector((state) => state.user.user);

  useEffect(() => {
    const timer = setTimeout(() => {
      // TODO: Re-enable login when auth is ready
      const skipLogin = true; // process.env.REACT_APP_SKIP_LOGIN === 'true';

      if (skipLogin || user) {
        navigate(routes.home);
      } else {
        navigate(routes.onboarding);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [user, navigate]);

  return (
    <div
      className="flex items-center justify-center h-screen w-full"
      style={{
        background: `linear-gradient(135deg, ${colors.gradient1} 0%, ${colors.gradient2} 50%, ${colors.gradient1} 100%)`,
      }}
    >
      <div
        className="w-16 h-16 rounded-full flex items-center justify-center text-3xl font-bold"
        style={{ backgroundColor: colors.white, color: colors.primary }}
      >
        F
      </div>
      <CText type="B30" color={colors.white} className="ml-4">
        {strings.fyntrai}
      </CText>
    </div>
  );
};

export default Splash;
